import React, { useState } from "react";
import Layout from "../components/Layout";

function RedemptionPage() {
  const [redemptionCode, setRedemptionCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);

  const handleRedeem = async () => {
    if (!redemptionCode.trim()) {
      setError("Please enter a valid redemption code.");
      return;
    }

    setIsLoading(true);
    setError(null);
    setMessage("");

    try {
      const REDEMPTION_API_URL =
        "https://rirrov5292.execute-api.us-east-1.amazonaws.com/Dev/redeem";

      const authData = localStorage.getItem("authData");
      const parsedAuthData = authData ? JSON.parse(authData) : null;
      const userId = parsedAuthData?.user?.sub;

      if (!userId) {
        setError("You are not logged in. Please log in to redeem your code.");
        return;
      }

      // Convert redemption code to uppercase
      const upperCaseCode = redemptionCode.trim().toUpperCase();

      const payload = {
        body: JSON.stringify({
          userId,
          code: upperCaseCode, // Send the uppercase code
        }),
      };

      const response = await fetch(REDEMPTION_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload), // Convert payload to string
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        setMessage("Redemption code accepted. Thank you!");
        setRedemptionCode(""); // Clear the input field
      } else {
        const errorMessage = JSON.parse(data.body).message || "Failed to redeem code.";
        setError(errorMessage);
      }
    } catch (err) {
      setError(err.message || "An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <div className="container mx-auto mt-10 max-w-2xl bg-white shadow-md p-10 rounded-md">
        <h1 className="text-xl font-semibold mb-6">Redeem Your Code</h1>
        <p className="text-gray-600 mb-6">
          Enter your redemption code below and click "Redeem" to validate it.
        </p>
        <p className="text-green-600 mb-6 font-bold">
          You can request a free code from 
          <a href="/contactUs" className="text-blue-500 underline ml-1">
                   Contact Us
          </a> 
        
        </p>

        {/* Redemption Code Input */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Redemption Code
          </label>
          <input
            type="text"
            className="w-full p-2 border rounded-md"
            value={redemptionCode}
            onChange={(e) => setRedemptionCode(e.target.value)}
            placeholder="Enter your redemption code"
            disabled={isLoading}
          />
        </div>

        {/* Error and Success Messages */}
        {error && <p className="text-red-500 mb-4">{error}</p>}
        {message && <p className="text-green-500 mb-4">{message}</p>}

        {/* Action Buttons */}
        <div className="flex justify-between">
          <button
            className="bg-gray-200 text-gray-700 py-2 px-6 rounded-md hover:bg-gray-300 disabled:bg-gray-100 disabled:text-gray-400"
            onClick={() => setRedemptionCode("")}
            disabled={isLoading}
          >
            Reset
          </button>
          <button
            className="bg-blue-500 text-white py-2 px-6 rounded-md hover:bg-blue-600 disabled:bg-blue-300"
            onClick={handleRedeem}
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : "Redeem"}
          </button>
        </div>
      </div>
    </Layout>
  );
}

export default RedemptionPage;
